<template>
  <v-menu
    :close-on-content-click="false"
    v-model="menuOpened"
    :nudge-width="450"
    max-width="600"
    transition="scale-transition"
  >
    <template v-slot:activator="{ on }">
      <v-tooltip top>
        <template v-slot:activator="{ on: onTooltip }">
          <v-btn icon
                 class="mr-2"
                 :color="iconColor"
                 v-on="{ ...onTooltip, ...on }"
                 @click.stop.prevent=""
          >
            <v-icon>mdi-filter-outline</v-icon>
          </v-btn>
        </template>
        <span>Filtrar por</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-card-text class="text--primary">
        <v-row dense class="mt-1">
          <v-col cols="12" sm="6">
            <px-date-picker dense
                            input-class="rounded-tag-small"
                            label="Data de execução inicial"
                            v-model="localDataInicial"/>
          </v-col>
          <v-col cols="12" sm="6">
            <px-date-picker dense
                            input-class="rounded-tag-small"
                            label="Data de execução final"
                            v-model="localDataFinal"/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <px-select-enum
              dense
              multiple
              chips
              small-chips
              label="Levels"
              deletable-chips
              :items="levels"
              class="rounded-tag-small"
              v-model="localLevel"/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <px-select-enum
              dense
              multiple
              chips
              small-chips
              label="Tipos"
              deletable-chips
              :items="tipos"
              class="rounded-tag-small"
              v-model="localTipo"/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="pa-3">
        <v-spacer/>
        <v-btn text class="normal-btn-text" @click="clearFilters">
          Limpar filtros
        </v-btn>
        <v-btn color="primary"
               class="normal-btn-text rounded-tag-small elevation-0"
               @click="emitChange">
          Aplicar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex';
import { LevelLog, LogType } from 'px-business-components';

export default {
  props: {},
  data: () => ({
    menuOpened: false,
    localTipo: null,
    localLevel: null,
    localDataInicial: null,
    localDataFinal: null,
    tipos: LogType.values,
    levels: LevelLog.values,
  }),
  computed: {
    ...mapGetters('painelIntegracao', ['hasCustomFilters']),
    iconColor() {
      return this.hasCustomFilters ? 'primary' : '';
    },
    tipo: {
      get() {
        return this.$store.getters['painelIntegracao/tipo'];
      },
      set(tipo) {
        this.$store.dispatch('painelIntegracao/tipo', tipo);
      },
    },
    level: {
      get() {
        return this.$store.getters['painelIntegracao/level'];
      },
      set(level) {
        this.$store.dispatch('painelIntegracao/level', level);
      },
    },
    dataFinal: {
      get() {
        return this.$store.getters['painelIntegracao/dataFinal'];
      },
      set(dataFinal) {
        this.$store.dispatch('painelIntegracao/dataFinal', dataFinal);
      },
    },
    dataInicial: {
      get() {
        return this.$store.getters['painelIntegracao/dataInicial'];
      },
      set(dataInicial) {
        this.$store.dispatch('painelIntegracao/dataInicial', dataInicial);
      },
    },
  },
  methods: {
    emitChange() {
      this.level = this.localLevel;
      this.tipo = this.localTipo;
      this.dataInicial = this.localDataInicial;
      this.dataFinal = this.localDataFinal;
      this.$emit('change');
      this.close();
    },
    clearFilters() {
      this.localLevel = null;
      this.localTipo = null;
      this.localDataInicial = null;
      this.localDataFinal = null;
      this.emitChange();
    },
    close() {
      this.menuOpened = false;
    },
  },
  created() {
    this.localLevel = this.level || [];
    this.localTipo = this.tipo || [];
    this.localDataInicial = this.dataInicial || null;
    this.localDataFinal = this.dataFinal || null;
  },
};
</script>
